<template>
	<el-container>
		<Menu :activeIndex='activeIndex'></Menu>
		<el-container>
			<el-header>
				<h2>话题分类管理</h2>
				<el-button size="medium" plain type="success" id='btn_add' @click="dialogBannerVisible = true,clearform()">新增话题分类</el-button>
			</el-header>
			<el-main>
				<!-- 表格 -->
				<el-table :data="tableData" style="width: 100%;" :stripe="true" :border='true' :default-sort="{prop: 'date', order: 'descending'}">
					<el-table-column label="序号" width="100">
						<template slot-scope="scope">
							<div v-text="scope.$index+1"></div>
						</template>
					</el-table-column>
          <el-table-column prop="id" label="id" :show-overflow-tooltip="true"></el-table-column>
					<el-table-column prop="name" label="分类名称" :show-overflow-tooltip="true"></el-table-column>
          <el-table-column prop="sort" label="排序" :show-overflow-tooltip="true"></el-table-column>

					<el-table-column label="操作">
						<template slot-scope="scope">
							<el-button-group>
								<el-button type="primary" size="mini" plain @click="handleEdit(scope.$index, scope.row),dialogBannerVisible = true">编辑</el-button>
								<el-button size="mini" plain type="danger" @click="handleDelete(tableData, scope.row,scope.$index)">删除</el-button>
							</el-button-group>
						</template>
					</el-table-column>
				</el-table>
			</el-main>
			<el-footer>Copyright &copy; Soren经济学人 技术支持 ：
				<a href="#">Soren团队</a>
			</el-footer>
		</el-container>
		<el-dialog title="话题分类编辑" :visible.sync="dialogBannerVisible">
			<el-form :model="classify_param">
				<el-form-item label="话题分类名称" :label-width="formLabelWidth">
					<el-input v-model="classify_param.name" auto-complete="off"></el-input>
				</el-form-item>
        <el-form-item label="排序(越大越靠前)" :label-width="formLabelWidth">
          <el-input v-model="classify_param.sort" auto-complete="off"></el-input>
        </el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button @click="dialogBannerVisible = false">取 消</el-button>
				<el-button type="primary" @click="dialogBannerVisible = false,saveClassify()">确 定</el-button>
			</div>
		</el-dialog>
	</el-container>
</template>
<script>
	export default {
		data() {
			return {
				activeIndex: "14",
				tableData: [],
				formLabelWidth: "150px",
				dialogBannerVisible: false,
				classify_param: {
					mark: 'xueqiu',
					name: "",
					imgurl: "",
					id: "",
          sort:0
				},
        requestUrl : 'https://soren.guanqimiao.cn',  //正式上线后改为 https://soren.guanqimiao.cnrequestUrl : 'https://soren.guanqimiao.cn',
			};
		},
		created() {
			this.getData();
		},
		updated: function() {
			this.ifHavemark();
		},
		methods: {
			// 页面 表格数据 初始化
			getData() {
				var self = this;
				self.axios.post(self.requestUrl + "/Topic/getAllTopicCategory", {
						mark: localStorage.getItem("mark")
					})
					.then(function(response) {
						if(response.status === 200) {
							self.tableData = response.data;
						} else if(response.data.code == "400") {
							self.$message({
								type: "error",
								message: "操作失败"
							});
						} else {
							self.ifLogin();
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			//form 表单 数据
			saveClassify() {
				var self = this;
				self.axios.post(self.requestUrl + "/Topic/addTopicCategiry", self.classify_param)
					.then(function(response) {
						console.log(response);
						if(response.status === 200) {
							self.$message({
								message: "添加/编辑成功",
								type: "success"
							});
							self.getData();
						} else if(response.data.code == "400") {
							self.$message({
								type: "error",
								message: "操作失败"
							});
						} else {
							self.ifLogin();
						}
					})
					.catch(function(error) {
						console.log(error);
					});
			},
			clearform() {
				var self = this;
				self.classify_param = {
					mark: 'xueqiu',
					name: "",
					id: "",
          sort : ""
				}
			},
			handleEdit(index, row) {
				var that = this;
				that.classify_param = {
					mark: 'xueqiu',
					name: row.name,
					id: row.id,
          sort : row.sort
				}
			},
			handleDelete(rows, row, index) {
				var self = this;
				self.$confirm("确认删除该课程分类?", "提示", {
						confirmButtonText: "确定",
						cancelButtonText: "取消",
						type: "warning"
					})
					.then(() => {
						self.axios.post(self.requestUrl + "/Topic/deleteTopicCategory", {
								mark: localStorage.getItem("mark"),
								id: row.id
							})
							.then(function(response) {
								if(response.data.code == "600") {
									self.$message({
										message: "删除成功",
										type: "success"
									});
									self.getData();
								} else if(response.data.code == "400") {
									self.$message({
										type: "error",
										message: "操作失败"
									});
								} else {
									self.ifLogin();
								}

							})
							.catch(function(error) {
								console.log(error);
							});
					})
					.catch(() => {
						self.$message({
							type: "info",
							message: "已取消删除"
						});
					});
			}
		}
	};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
	.el-header {
		position: relative;
	}

	.el-header h2 {
		margin: 0;
		line-height: 60px;
	}

	.el-header #btn_add {
		position: absolute;
		right: 25px;
		top: 12px;
	}

	.avatar-uploader .el-upload {
		border: 1px dashed #d9d9d9;
		border-radius: 6px;
		cursor: pointer;
		position: relative;
		overflow: hidden;
	}

	.avatar-uploader .el-upload:hover {
		border-color: #67c23a;
	}

	.avatar-uploader-icon {
		font-size: 28px;
		color: #8c939d;
		width: 100px;
		height: 100px;
		line-height: 100px !important;
		text-align: center;
	}

	.avatar {
		width: 100%;
		height: auto;
		display: block;
	}

	.Saveid {
		cursor: pointer;
		color: #67c23a;
		display: block;
	}

	.menupart {
		width: 50px;
		height: 50px;
		border-radius: 50%;
		position: relative;
	}

	.menupart img {
		display: block;
		max-width: 60%;
		position: absolute;
		left: 0;
		right: 0;
		top: 0;
		bottom: 0;
		margin: auto;
	}

	.edit_bg {
		display: inline-block;
		width: 80px;
	}
</style>



// WEBPACK FOOTER //
// src/components/TopicCategory.vue